import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const Mission = () => {
    useEffect(() => {
        document.title = 'Mission -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header">
                <div className="page-header__inner">
                    <h2>Mission</h2>
                    <ul className="thm-breadcrumb list-unstyled ml-0">
                        <li><Link to="/"> Home</Link></li>
                        <li>|</li>
                        <li>About</li>
                        <li>|</li>
                        <li> Mission</li>
                    </ul>
                </div>
            </section>
            <section className="innerbody">
                <div className='container'>
                    <div className='row'>
                        
                        <div className='col-md-12'>
                            <p>To fulfill the vision, the school aims to provide an environment in which every student discovers and realizes his/her full potential. The school should attract the most talented students, teachers and facilitators from all walks of society without distinction of race, religion, caste or social status.</p>
                            <p>The mission of the school is to empower all its students to be problem solvers, users of technology, effective communicators and life long learners in a rapidly changing global community by providing challenging experiences in a safe, caring ,supportive and co-operative environment and prepare them to be successful and happy in this highly competitive and challenging future global scenario.</p>
                            <p>The school aims at the broader development of complete personality of its students by creating :</p>
                            <ul className="list schoolfee">
                                <li>An understanding and appreciation of India's rich culture.</li>
                                <li>A sense of integrity , ethics and uncompromising honesty.</li>
                                <li>A strong secular ethos.</li>
                                <li>Leadership with a sense of team work and play.</li>
                                <li>An awareness on the environment.</li>
                                <li>A concern for the less fortunate.</li>
                                <li>A concern for human rights and democratic values.</li>
                                <li>A questioning mind and a spirit of adventure.</li>
                            </ul>
                        </div>
                    </div>
                </div>
             </section>
            <Footer/>
        </>
    )
}

export default Mission